import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import App from './App.js';
import './design-system.css';
import './site.css';

import { GoogleOAuthProvider } from '@react-oauth/google';

import { ThemeProvider } from './hooks/ThemeContext.js';

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Root element not found');
}

const clientId = import.meta.env.VITE_GOOGLE_CLIENT_ID;

createRoot(rootElement).render(
  <StrictMode>
    <GoogleOAuthProvider clientId={clientId || ''}>
      <ThemeProvider>
        <App />
      </ThemeProvider>
    </GoogleOAuthProvider>
  </StrictMode>,
);
